<div class="no-items-found-wrapper sp-mt-24 sp-mb-24">
  <span class="nc-icon-outline food_pizza-slice fs-40px text-color-gray-4"></span>
  <div class="text-color-gray-4 sp-ml-20 fs-18px">{{ message }}</div>
</div>
